import React from 'react';
import { UserHeader } from 'shared/ui/user-header/user-header';
import { BusinessApi } from 'shared/api';
import { UserRoleEnum, userStore } from 'entities/index';

interface IManagerHeaderProps {
  managerId: string;
  dataFio: string;
  dataEmail: string;
  dataPhone: string;
  dataImgUrl: string;
}
export const ManagerHeader: React.FC<IManagerHeaderProps> = ({
  managerId,
  dataFio,
  dataPhone,
  dataImgUrl,
  dataEmail,
}) => {
  const handleDelete = async () => {
    if (managerId) {
      await BusinessApi.deleteManager({ managerId });
    }
  };

  const deleteButton = [
    UserRoleEnum.OWNER,
    UserRoleEnum.ADMINISTRATOR,
  ].includes(userStore.role)
    ? { text: 'Удалить менеджера', onClick: handleDelete }
    : undefined;

  return (
    <UserHeader
      fio={dataFio}
      phone={dataPhone}
      email={dataEmail}
      imgUrl={dataImgUrl}
      onSaveImage={(url: string) =>
        BusinessApi.updateManagerInfo({ managerId, imgUrl: url })
      }
      deleteButton={deleteButton}
      successMessage={deleteButton ? 'Менеджер успешно удален' : undefined}
    />
  );
};
